<template>
  <div>
    <fieldset>
      <div class="m-3">
        <h6>Alıcı Detayları</h6>
        <hr>
        <div style="display: flex; flex-direction: column; gap: 10px;">
          <div class="finalizerField">
            <b>Alıcı Adı : </b>
            <p class="finalizerText">{{ data.TargetSystem.Name }}</p>
          </div>
          <div class="finalizerField">
            <b>Türü : </b>
            <p class="finalizerText">{{ data.TargetSystem.Kind | finalizerKind }}</p>
          </div>
          <div class="finalizerField" v-for="e in data.TargetSystem.ExtraFields" :key="e.Key">
            <b>{{ e.Key }} :</b>
            <p class="finalizerText">{{ e.Value }}</p>
          </div>
          <div class="finalizerField">
            <b>Durum :</b>
            <finalizer-state-icon :state="data.State" :show-label="true" />
          </div>
          <div style="display: flex; flex-direction: column; margin-top: 10px;" v-show="data.Results && data.Results.length > 0">
            <b>İşlem Geçmişi</b>
            <div style="display: flex; flex-direction: column; border: 1px solid lightgrey; border-radius: 5px; padding: 5px; margin-top: 10px;">
              <div v-for="r in finalizerResults" :key="r.Date">
                <div>
                  <finalizer-state-icon :state="r.State" :show-label="false" />
                  <div v-show="r.Count > 1" title="Tekrar sayısı" class="text-danger" style="font-size:12px;">
                    x{{ r.Count }}</div>
                </div>
                <div style="white-space: pre-wrap; overflow-x: auto; padding-bottom: 5px">
                  <div>{{ r.Description }}</div>
                  <small v-if="r.ExceptionData" class="text-muted" style="text-overflow: ;">{{ r.ExceptionData.Message }}</small>
                  <div v-if="r.User">{{ r.User.FullName }}</div>
                </div>
                <div>
                  {{ r.Date | datetime }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="commands">
        <div class="row">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-secondary" @click="$emit('back')">
              Geri
            </button>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>

import finalizerStateIcon from '../components/FinalizerStateIcon.vue';
export default {
  components: {
    finalizerStateIcon
  },
  data() {
    return {
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    finalizerResults() {
      return [...this.data.Results].reverse(); //.reverse();
    }
  }
};
</script>

<style scoped>
b {
  min-width: fit-content;
}

.finalizerField {
  border: 1px solid lightgrey;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 10px;
  border-radius: 5px;
}

.finalizerText {
  padding: 0;
  margin: 0;
}
</style>
